import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

import {ConfirmDialogData, ConfirmDialogResultType} from '../../models';

@Component({
  selector: 'lib-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss']
})
export class ConfirmDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogData
  ) {
  }

  onOk() {
    this.data.result = ConfirmDialogResultType.Ok;
    this.dialogRef.close(this.data);
  }

  onCancel() {
    this.data.result = ConfirmDialogResultType.Cancel;
    this.dialogRef.close(this.data);
  }
}
